module.exports = __webpack_public_path__ + "static/media/10.67fbdef7.jpg";